// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__15Ttq","row":"ProcedureTreatmentSummary_row__2Z6Q-"};